import { render } from "./tables.vue?vue&type=template&id=0c209c8e&scoped=true&ts=true"
import script from "./tables.vue?vue&type=script&lang=ts"
export * from "./tables.vue?vue&type=script&lang=ts"

import "./tables.vue?vue&type=style&index=0&id=0c209c8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c209c8e"]])

export default __exports__